import { Base } from "./Base";
import { EParagraphType, IParagraph, 
         ITransactionDates, IExif
} from "./shared/types";
import { Exif } from "@/components/shared/Exif";

import { Request } from "./Request";
import { Job } from "./Job";

import i18n from "@/common/filters";
import { createDate } from "@/common/utils";
import { urls, APIID } from "@/common/http";

export class Paragraph extends Base implements IParagraph {
  HalloId: string;
  Type: EParagraphType;
  Text: string;
  SourceUri: string;
  Dates: ITransactionDates = {};

  Exif: IExif;
  Request: Request;
  Job?: Job;

  MediaURLTimeStamp: number = (new Date()).getTime();

  protected _propertyNames = [
    'HalloId', 'Type', 'Text', 'SourceUri', 'Dates', 'Exif'
  ];

  constructor(paragraph?:IParagraph) {
    super();
    if (paragraph) {
      this.Properties = paragraph;
    }
  }

  get Properties() : IParagraph {
    return <IParagraph>this.getProperties();
  }

  set Properties(paragraph: IParagraph) {
    for (let p in paragraph) {
      if (this._propertyNames.indexOf(p) != -1) {
        this[p] = paragraph[p];
      }
    }
  }

  set PropertiesFromStorage(paragraph:any) {
    if (paragraph.id && paragraph.id!=this.HalloId) {
      this.HalloId = paragraph.id;
    }
    if (paragraph.type_em && paragraph.type_em!=this.Type) {
      this.Type = paragraph.type_em;
    }
    if (paragraph.text && paragraph.text!=this.Text) {
      this.Text = paragraph.text.replace(/\\"/g,'"');
    }
    if (paragraph.media_path && paragraph.media_path!=this.SourceUri) {
      this.SourceUri = paragraph.media_path;
      this.MediaURLTimeStamp = (new Date()).getTime();
    }
    if (paragraph.dates) {
      this.Dates = this.Dates || {};
      let p;
      let mapping = {
        create_ts: 'Created',
        update_ts: 'Updated',
        complete_ts: 'Completed',
        delete_ts: 'Deleted'
      };
      for (p in mapping) {
        if (paragraph.dates[p]) {
          this.Dates[mapping[p]] = createDate(paragraph.dates[p]);
        }
      }
    }
  }

  get Index() : number {
    //buggy. Job.Result is also instanceof Paragraph. This this index then will be wrong if called from Jbo.Result
    try {
      let i;
      if (this.Job) {
        i = this.Job.Results.indexOf(this);
      }
      if (i < 0) {
        i = this.Request.Contents.indexOf(this);
      }
      return i;
    } catch (error) {
      return this.Request.Contents.indexOf(this);
    }
  }

  ImageURL?: any = '';
  async createImageURL(file:File) {
    try {
      this.ImageURL = await Exif.createImageURL(file);
    } catch (error) {
      console.log(error);
    }
  }
  
  private _File?: File; //temporary store a file to be uploaded
  
  get File() : File {
    return this._File;
  }

  set File(file:File) {
    this._File = file;
    this.createImageURL(file);
  }

  get MediaURL() : string {
    let match;
    if (this.HalloId && this.Request && this.Request.HalloId) {
      match = this.HalloId + '|' + this.Request.HalloId;
    } else if (this.HalloId) {
      match = this.HalloId;
    } else if (this.Request && this.Request.HalloId) {
      match = this.Request.HalloId;
    }
    if (!this.SourceUri) {
      return null;
    //} else if (this.SourceUri instanceof MediaAsset) {
    //  return this.SourceUri;
    } else if (match && this.SourceUri.match(new RegExp(match,'i'))) {
      let url = urls.request.url + '/image/' + this.SourceUri + 
                '?APIID=' + APIID + '&width=' + Math.ceil(this.DisplayWidth) +
                '&ts=' + this.MediaURLTimeStamp;
      return url;
    }
    return this.SourceUri;
  }

  get HtmlText() : string {
    if (!this.Text) {
      return '';
    }
    let texts = this.Text.split('\\n');
    let html = ''; //'<!DOCTYPE html><html><body style="padding:0;margin:0;background-color:#0000ff">';
    html += '<div>';
    texts.forEach((t) => {
      t = t.replace(/\\"/g,'"');
      html += '<p>' + t + '</p>';
    });
    //html += this.Text.replace('\\n','<br>'); //HtmlView does not size correctly to account for <br>
    html += '</div>';
    //html += '</body></html>';
    return html;
  }

  get HtmlTextForEdit() : string {
    if (this.Text) {
      return this.HtmlText;
    }
    let html = ''; //'<!DOCTYPE html><html><body style="padding:0;margin:0;background-color:#0000ff">';
    html += '<div style="font-family:sans-serif;font-size:15">'
    html += i18n.L('sTapToAddText');
    html += '</div>';
    //html += '</body></html>';
    return html;
  }

  get ActionsTop() : number {
    let t = this.Index * 152 + 1;
    let v = this.Request.VisibleAction;
    if (v>=0 && v<this.Index) {
      t += 10;
    }
    return t;
  }

  get ParagraphTop() : number {
    let t = this.Index * 152 + 1;
    let v = this.Request.VisibleAction;
    if (v>=0 && v<=this.Index) {
      t += 10;
    }
    return t;
  }

  get ActionVisibility1() : string {
    return (this.VisibleAction!=this.Index) ? 'visible' : 'collapsed';
  }

  get ActionVisibility2() : string {
    return (this.VisibleAction==this.Index) ? 'visible' : 'collapsed';
  }

  get VisibleAction() : number {
    return this.Request.VisibleAction;
  }

  private _loading: boolean = true;
  get Loading() : boolean {
      return this._loading;
  }
  
  onLoaded(args) {
    setTimeout(() => {
      this._loading = false;
    },600);
  }

  setActionVisibility(args) {
    let action = args.object.action;
    if (action != this.VisibleAction) {
      this.Request.setActionVisibility(action);
    }
  }
}
